module.exports = __webpack_public_path__ + "static/prize-02-1c630f60dc79b9a05c138c1da92e0046.png";